module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/icon_number_14-d29aa6205948cf2cc5a0124412fc2b74.svg";